<script lang="ts">
  import { optionsData } from "../../ts/Stores";

  import type { ISpacing, ISpacingOptions } from "../../ts/Interfaces";
  import Spacing from "./Spacing.svelte";

  export let spacing: ISpacing;

  let options: ISpacingOptions;
  optionsData.subscribe((optionsData) => {
    options = optionsData.spacingOptions;
  });
</script>

<div class="flex-wrap">
  {#if !spacing.hideMargin}
    <Spacing
      label="Configure margin to apply"
      min={options.minMargin}
      max={options.maxMargin}
      step={parseFloat(options.incrementsBy)}
      bind:spacing={spacing.margin}
    />
  {/if}
  {#if !spacing.hidePadding}
    <Spacing
      label="Configure padding to apply"
      min={options.minPadding}
      max={options.maxPadding}
      step={parseFloat(options.incrementsBy)}
      bind:spacing={spacing.padding}
    />
  {/if}
</div>
